<form class="my-listing" [formGroup]="formValues">
  <main role="main">
    <div class="jumbotron banner-item" [ngStyle]="getBackgroundImageStyle(listingDetails.images ? listingDetails.images[0] : '')">
      <div class="container Hduwn Egfus" style="max-width: 100vw;padding: 0px;">
        <div class="scrim" style="display: inline-block;">
          <mat-chip-list aria-label="Fish selection">
            <!-- <mat-chip>One fish</mat-chip>
                <mat-chip>Two fish</mat-chip>
                <mat-chip color="primary" selected>Primary fish</mat-chip> -->
            <mat-chip color="accent" *ngFor="let category of listingDetails.category" selected>{{
            category
          }}</mat-chip>
          </mat-chip-list>
          <h2><input matInput type="text" placeholder="Enter Item Name" formControlName="name" /></h2>
        </div>
      </div>
    </div>
  </main>
  <div class="container cvjEh">
    <div class="row">
      <div class="col-lg-6">
        <div class="col-lg-12">
          <label class="section-header">
            Description
          </label>
          <input matInput type="text" placeholder="Enter Item Description" formControlName="description" />
        </div>
        <div class="col-lg-12 details-section">
          <hr class="section-separator" />
          <label class="section-header">
            Date
          </label>
          <mat-form-field>
            <input matInput [min]="today" [max]="maxDateForPicker" [value]="startDate" formControlName="startDate"
              [matDatepicker]="startDatePicker" placeholder="Start date" (dateChange)="onDate($event)" disabled>
            <mat-datepicker-toggle matSuffix [for]=" startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <input matInput [min]="pickerMinDate2" [max]="maxDateForPicker" [value]="endDate"
              [matDatepicker]="endDatePicker" placeholder="End date" formControlName="endDate" disabled>
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <br />
        </div>
        <div class="col-lg-12 details-section">
          <hr class="section-separator" />
          <label class="section-header">
            Price
          </label>
          <select formControlName="currency">
            <option [value]="currency" *ngFor="let currency of currencies">{{currency}}</option>
          </select>
          <mat-form-field class="Bsuwn example-full-width">
            <input matInput type="number" placeholder="Price" formControlName="rentalPrice" step="0.01"
              style="padding-left: 65px;" />
          </mat-form-field>
          <br />
        </div>
        <div class="col-lg-12 details-section">
          <hr class="section-separator" />
          <label class="section-header">
            Location
          </label>
          <mat-card class="map-card">
            <div class="address-wrap">
              <input matInput type="text" placeholder="Enter Address" formControlName="location" />
            </div>
          </mat-card>
          <br />
        </div>
        <div class="col-lg-12 specs-section">
          <hr class="section-separator" />
          <label class="section-header">
            Specifications
          </label>
          <div class="specs-list-wrap">
            <ul>
              <li *ngFor="let specification of listingDetails.specifications">
                {{ specification.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-12 availability-section">
          <hr class="section-separator" />
          <label class="section-header">
            Availability
          </label>
          <app-ri-calendar class="range-calendar" (onDateRangeSelected)="changeDateRangeCal1($event)"
            (onDateReset)="resetValues($event)" [dates]="dates" [reservedDates]="reservedDates" [reservationPage]="true"
            [datePicker]="true" #cal1></app-ri-calendar>
        </div>
      </div>
      <div class="col-lg-6" style="padding: 0px;">
        <div class="price-detail-wrap">
          <div class="row">
            <div class="col-lg-12">
              <div class="row calendar-wrap">
                <button class="Gydhwj" mat-button (click)="updateListing(listingDetails.id)"
                  [disabled]="!formValues.valid">
                  Update Listing
                </button>
                <div class="col col-lg-12" style="padding:0px;">
                  <hr />
                  <div class="row">
                    <div class="col-lg-2"
                      style="padding-right:0px;display: flex;justify-content: center;align-items: center;">
                      <img src="../../../../assets/img/sprite-info.png" style="width:40px;" />
                    </div>
                    <div class="col-lg-9 no-padding info">
                      <label>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                        tempor incididunt ut labore.</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>